/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from '@msdyn365-commerce-modules/utilities';
import { IEveSoboCheckerViewProps } from './eve-sobo-checker';

export default (props: IEveSoboCheckerViewProps) => {
    const {
        showModal,
        closeModal,
        renderLink,
        renderTable,
        cartNotEmpty,
        resources: {
            cartWarning,
            selectUserHeading
        }
    } = props;
    
    return (
        <div className="container">
            <div className='eve-sobo-checker'>
                {renderLink}
            </div>
            
            <Modal isOpen={showModal}>
                <ModalBody>
                    <h2>{selectUserHeading}</h2>
                    <div className='eve-sobo-wrapper'>
                        {cartNotEmpty ? cartWarning : renderTable}     
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button className='msc-order-template-name-dialog__dialog__cancel-button msc-btn msc-btn' onClick={closeModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};
